var _react_refresh_temp_1, _react_refresh_temp_2;
var _react_refresh_temp_3;
_react_refresh_temp_3 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { getMonitor } from '../../mock/health';
const MonitorAlert = ({ type }) => {
    _react_refresh_temp_3();
    const TIME_INTERVAL = 2000;
    const [monitor, setMonitor] = useState({});
    const [alertCss, setAlertCss] = useState('no-alert');
    const monitorValue = () => { var _a; return (_a = monitor.value) !== null && _a !== void 0 ? _a : '-'; };
    const monitorUnit = () => { var _a; return (_a = monitor.unit) !== null && _a !== void 0 ? _a : '-'; };
    useEffect(() => {
        const interval = setInterval(() => {
            var _a;
            const realTimeMonitor = getMonitor(type);
            const alertType = (_a = realTimeMonitor === null || realTimeMonitor === void 0 ? void 0 : realTimeMonitor.alert) !== null && _a !== void 0 ? _a : false;
            setMonitor(realTimeMonitor !== null && realTimeMonitor !== void 0 ? realTimeMonitor : {});
            setAlertCss(alertType ? 'alert' : 'no-alert');
        }, TIME_INTERVAL);
        return () => clearInterval(interval);
    }, []);
    return ((_jsxs("div", { className: `monitor-alert ${alertCss}`, children: [_jsx("div", { className: 'title', children: type }), _jsxs("div", { className: 'content', children: [_jsx("div", { className: 'monitor-value', children: monitorValue() }), _jsx("div", { className: 'monitor-unit', children: monitorUnit() })] })] })));
};
_react_refresh_temp_1 = MonitorAlert;
$RefreshReg$(_react_refresh_temp_1, "MonitorAlert");
_react_refresh_temp_3(MonitorAlert, "++gFTKcfo3zc8bi8xGFDjNM4Qe4=");
export default _react_refresh_temp_2 = React.memo(MonitorAlert);
$RefreshReg$(_react_refresh_temp_2, "%default%");
